// const getFormData = (form) => {
//     if (!form.checkValidity()) {
//         form.reportValidity()
//         return
//     }
//     const formData = new FormData(form)
//     let object = {};
//     formData.forEach((value, key) => {
//         if (value !== "") object[key] = value
//         if (value === "on") object[key] = true
//     });
//     return object;
// }

const truncateText = (text, maxLength) => {
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
}

const zodSubmit = (event, setErrors, handleSubmit, schema) => {
    event.preventDefault();
    // console.log('submit')

    const formData = new FormData(event.target);
    const values = Object.fromEntries(formData.entries());
    // console.log(values)
    const result = schema.safeParse(values);

    if (!result.success) {
        const fieldErrors = {};
        const issues = JSON.parse(result.error.message);
        // console.log(issues)
        issues.forEach(err => {
            fieldErrors[err.path[0]] = err.message;
        });
        setErrors(fieldErrors);
        return false;
    }
    // console.log('success')
    setErrors({});
    handleSubmit(values);
    return true
};

const hasFormChanged = (form, initial) => {
    const formData = new FormData(form);
    const values = Object.fromEntries(formData.entries());

    return Object.keys(initial).some(key => {
        return (values[key] ?? "") !== (initial[key] ?? "");
    });
};

export {zodSubmit, truncateText, hasFormChanged}